import React from 'react';

import { CheckCircleRounded, InfoRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

type HeaderInfoProps = {
  header: string;
  title: string;
  iconType?: 'info' | 'tick';
};

function HeaderInfo({ header, title, iconType = 'info' }: HeaderInfoProps) {
  return (
    <Box
      className="MuiDataGrid-columnHeaderTitleContainer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        cursor: 'default', // Mimics the non-interactive behavior
      }}
      title={title}
    >
      <Typography
        variant="body2"
        className="MuiDataGrid-columnHeaderTitle"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontWeight: 'inherit', // Inherit the weight to align with DataGrid
        }}
      >
        {header}
      </Typography>
      {iconType === 'info' && <InfoRounded fontSize="small" sx={{ ml: 0.5 }} />}
      {iconType === 'tick' && <CheckCircleRounded fontSize="small" sx={{ ml: 0.5 }} />}
    </Box>
  );
}

export default HeaderInfo;
